import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import { Link } from 'react-router';
import shallowEqual from 'react-pure-render/shallowEqual';
import has from 'lodash/has';
import findIndex from 'lodash/findIndex';

import { loadEvent, setHeader, loadInbox } from 'actions';

import Icon from 'components/common/Icon';
import Loading from 'components/common/Loading';
import EventDetails from 'components/calendar/EventDetails';

class InboxDetailPage extends Component {
  static loadData(props) {
    const { event_id } = props;

    props.loadEvent(event_id);
    if (!has(props, 'inbox.events') || props.inbox.events.length < 1) {
      props.loadInbox();
    }
  }

  constructor(props) {
    super(props);

    this.navigatePreviousItem = this.navigatePreviousItem.bind(this);
    this.navigateNextItem = this.navigateNextItem.bind(this);
  }

  componentWillMount() {
    InboxDetailPage.loadData(this.props);
    this.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.event_id && nextProps.event_id !== this.props.event_id) {
      InboxDetailPage.loadData(nextProps);
    }

    const currentEvents = has(this.props, 'inbox.events') ? this.props.inbox.events : [];
    const inboxChanged = (has(nextProps, 'inbox.events') && !shallowEqual(nextProps.inbox.events, currentEvents));
    const eventChanged = (nextProps.event &&
                          (!shallowEqual(nextProps.event, this.props.event) ||
                           !shallowEqual(nextProps.event.changes, this.props.event.changes)
                          )
                       );

    if (eventChanged || inboxChanged) {
      this.updateHeader(nextProps);
    }
  }

  navigatePreviousItem() {
    const { event_id } = this.props;

    if (has(this.props, 'inbox.events')) {
      const events = this.props.inbox.events;
      const position = findIndex(events, { id: event_id });

      if (position > 0) {
        this.props.push(`/inbox/details/${events[position - 1].id}`);
      }
    }
  }

  navigateNextItem() {
    const { event_id } = this.props;

    if (has(this.props, 'inbox.events')) {
      const events = this.props.inbox.events;
      const position = findIndex(events, { id: event_id });

      if (position < events.length - 1) {
        this.props.push(`/inbox/details/${events[position + 1].id}`);
      }
    }
  }

  updateHeader(props) {
    let rightAction;

    if (has(props, 'inbox.events')) {
      const events = props.inbox.events;
      const position = findIndex(events, { id: props.event_id });

      let leftArrow = (<Icon icon="arrow" size="medium" className="rotate-180 disabled" />);
      let rightArrow = (<Icon icon="arrow" size="medium" className="disabled" />);

      if (position > 0) {
        leftArrow = (
          <Icon icon="arrow" size="medium" className="rotate-180" clickable onClick={this.navigatePreviousItem} />
        );
      }

      if (position < events.length - 1) {
        rightArrow = (
          <Icon icon="arrow" size="medium" clickable onClick={this.navigateNextItem} />
        );
      }

      rightAction = (
        <span>
          {leftArrow} <span style={{ padding: 8 }} /> {rightArrow}
        </span>
      );
    }

    let inboxTitle = 'Requests';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
        inboxTitle = 'Inbox';
      }
    }

    if (has(window.CONFIG, 'enable_dashboard')) {
      if (window.CONFIG.enable_dashboard === '1') {
        inboxTitle = 'Dashboard';
      }
    }

    props.setHeader('Request', '/inbox', inboxTitle, rightAction);
  }

  render() {
    const { event, isLoading } = this.props;

    if (isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (event && !event.isLoading && !event.labels) {

      let inboxTitle = 'Requests';

      if (has(window.CONFIG, 'ui')) {
        if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
          inboxTitle = 'Inbox';
        }
      }

      if (has(window.CONFIG, 'enable_dashboard')) {
        if (window.CONFIG.enable_dashboard === '1') {
          inboxTitle = 'Dashboard';
        }
      }

      return (
        <div className="centered" style={{ minHeight: 200 }}>
          Invalid Request.
          <Link to="/inbox">Go Back to {inboxTitle}</Link>
        </div>
      );
    }

    return (
      <div className="inbox-page">
        <EventDetails event={event} hideUndecidedChanges />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { event_id } = state.router.params;
  const { inbox, calendar } = state;

  const event = calendar.events.all[event_id];

  const isLoading = !has(event, 'id') && !has(event, 'isError');

  return {
    event_id,
    event,
    isLoading,
    inbox,
    calendar,
  };
}

export default connect(mapStateToProps, {
  loadEvent,
  setHeader,
  loadInbox,
  push,
})(InboxDetailPage);



// WEBPACK FOOTER //
// ./src/app/containers/InboxDetailPage.js